
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Viele Menschen behaupten, vor allem am frühen Morgen von skurrilen Träumen geplagt zu werden. Einbildung oder Wahrheit? Beim Einschlafen gleitet man vom Leichtschlaf in eine Tiefschlafphase. In diesem entspannten Zustand sind die Traumphasen eher kurz und abstrakt. Die nächste Phase wird REM-Schlaf genannt, wobei REM für «Rapid Eye Movements» steht. Die Augen bewegen sich in dieser Phase unter den geschlossenen Lidern sehr schnell – hier sollen die Träume am intensivsten sein. `}<M mdxType="M">{`Im Morgengrauen wird der Schlaf leichter, weswegen sich die Schlafenden besser an das Geträumte erinnern können.`}</M>{` Gegen Morgen werden diese REM-Phasen immer länger; der Schläfer empfindet sie nun als besonders intensiv. Die Wissenschaftlerin Josie Malinowski von der University of East London hat im Rahmen einer Studie diese zunehmende Intensität bestätigt. Ihr Fazit: Kurz vor dem Aufwachen würden die Traumgeschichten immer surrealer und emotionaler, und häufig fühle sich das Geträumte in dieser Phase besonders echt an.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;